module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "flotilla"
    }
  }, [_c('div', {
    staticClass: "col-md-12 flecha-container"
  }, [_c('h1', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("FLOTILLA")]), _vm._v(" "), _c('img', {
    staticClass: "flecha",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1500",
      "src": require("imgs/icons/Flecha_Negra.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row flotillas-content-container"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "flotillas-updiv-img",
    staticStyle: {
      "z-index": "4"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "500"
    }
  }, [_c('img', {
    staticClass: "flotillas-updiv-img-truck",
    attrs: {
      "src": require("imgs/flotillas_truck4.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flotillas-updiv-img",
    staticStyle: {
      "z-index": "3"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    staticClass: "flotillas-updiv-img-truck",
    attrs: {
      "src": require("imgs/flotillas_truck3.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flotillas-updiv-img",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "2000"
    }
  }, [_c('img', {
    staticClass: "flotillas-updiv-img-truck",
    attrs: {
      "src": require("imgs/flotillas_truck2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flotillas-updiv-img",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "data-aos": "fade-right",
      "data-aos-duration": "4000"
    }
  }, [_c('img', {
    staticClass: "flotillas-updiv-img-truck",
    attrs: {
      "src": require("imgs/flotillas_truck1.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', {
    staticClass: "flotillas-updiv-text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("En A&A nuestra flotilla cuenta con unidades de las marcas International Prostar y Freightliner, todas en óptimas condiciones para entregas a cualquier punto de E.U.A. Contamos con servicio de mantenimiento a las unidades, departamento de lavado, mantenimiento preventivo correctivo y departamento de diagnóstico y reparación. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row flotillas-content-container"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "flotillas-bottomdiv-text",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_vm._v("Nuestra flotilla se compone de cajas secas de 53 pies de longitud listas para nuestros clientes. También contamos con servicio de almacenamiento de cajas cargadas en espera de documentación para ser exportadas y con unidades vacías listas para ser cargadas.  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-hidden"
  }, [_c('div', {
    staticClass: "flotillas-bottomdiv-img",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-duration": "1500"
    }
  }, [_c('img', {
    staticClass: "flotilla-truckimg",
    attrs: {
      "src": require("imgs/flotillas_dry.png")
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfdc30d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flotilla.vue
// module id = 84
// module chunks = 0